import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { isEmpty } from '../../helpers/common';
import { updateUserPreference } from '../../helpers/firebaseHelper';
import { appInit } from '../../services/appService';
import { ROUTES } from '../../routes/urls';
import AppLoading from '../../component/loading/appLoading';
import UserPreferenceSingleton from '../../helpers/userPreferenceSingleton';
import { getWorkspaceDetails } from '../../services/workspaceService';
import LayoutWithoutNavbar from '../../component/layoutWithoutNavbar';
import { captureException } from '../../services/logService';
const WorkspaceRedirect: React.FC = () => {
  // Other variables
  const history = useHistory();
  const params: { workspace_id: string } = useParams();

  const loadData = useCallback(async () => {
    if (!isEmpty(params?.workspace_id)) {
      try {
        const workspace = UserPreferenceSingleton.getInstance().getWorkspace();
        if (params?.workspace_id === workspace?.id) {
          history.push(ROUTES.INBOX);
          return;
        }
        const workspaceDetails = await getWorkspaceDetails(params?.workspace_id);
        if (!workspaceDetails) {
          history.push(ROUTES.INBOX);
          appInit();
          return;
        }
        await updateUserPreference({ current_workspace_id: params?.workspace_id });
        await appInit();
        history.push(ROUTES.INBOX);
      } catch (e) {
        captureException(e);
      }
    }
  }, [history, params?.workspace_id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div>
      <LayoutWithoutNavbar>
        <AppLoading />
      </LayoutWithoutNavbar>
    </div>
  );
};

export default WorkspaceRedirect;
